import styled from 'styled-components';

const ReportNameCell = styled.a`
  display: block;
  max-width: 32vw;

  color: ${(props): string => props.theme.colors.lqBlue};
  text-decoration: none;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export { ReportNameCell };
